<template>
    <div class="modal" v-bind:class="{'is-active':isActiveProjectUserPermissionModal}">
        <div class="modal-background"></div>
        <div class="modal-card animate__animated animate__fadeIn animate__faster" style="height:500px">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Role Permission</p>
                <button class="delete is-large" aria-label="close"
                        @click="openClosePermissionModal"></button>
            </header>


            <section class="modal-card-body" style="height: 500px">

                <div class="field">
                    <label class="label">Role Name</label>
                    <!--           <div v-if="selectedRoleId == 0" class="select is-fullwidth">
                                   <select v-model="permissionForm.roleId">
                                       <option v-for="role in filteredRoles" :key="role.id" :value="role.id">
                                           {{role.name}}
                                       </option>
                                   </select>
                               </div>-->


                    <div v-if="selectedRoleId == 0" class="select is-fullwidth">
                        <select @change="setRole($event.target.value)">
                            <option v-for="role in filteredRoles" :key="role.id" :value="role.id"
                            >
                                {{role.name}}
                            </option>
                        </select>
                    </div>


                    <div v-else class="select is-fullwidth">
                        <select>
                            <option v-for="role in filteredRoles" :key="role.id" :value="role.id" selected>
                                {{role.name}}
                            </option>
                        </select>
                    </div>

                </div>

                <div class="field">
                    <label class="label">Permission Name</label>
                    <div class="control">
                        <input v-model="permissionForm.name" class="input" required>
                    </div>
                </div>

                <div class="field">
                    <label class="label">Permission Description</label>
                    <div class="control">
                        <input v-model="permissionForm.description" class="input" required>
                    </div>
                </div>

            </section>

            <footer class="modal-card-foot">
                <div class="field is-right">
                    <div class="control">
                        <div class="control">
                            <button class="button modified-button" @click="TryAddProjectRolePermission()">
                                <span class="icon "><font-awesome-icon icon="save"/></span>
                                <span class="">Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapState} from "vuex"

    export default {
        name: "AddPermission",
        props: ['isActiveProjectUserPermissionModal', 'projectId', 'selectedRoleId'],
        data() {
            return {
                selectedPermissionRole: "",
                permissionForm: {
                    id: 0,
                    projectId: 0,
                    roleId: this.selectedRoleId,
                    name: "",
                    description: ""
                }
            }
        },
        methods: {

            ...mapActions('roles', ['getRoles', 'getRolesOfProject', 'addPermission', 'getRolePermissions']),
            async TryAddProjectRolePermission() {

                this.permissionForm.projectId = this.projectId;
                if (this.selectedRoleId != 0) {
                    this.permissionForm.roleId = this.selectedRoleId
                }

                if (this.permissionForm.roleId === 0) {
                    this.permissionForm.roleId = this.rolesOfProject[0].id;
                }


                try {
                    await this.addPermission(this.permissionForm);
                    await this.getRolePermissions(this.selectedRoleId);
                    this.openClosePermissionModal();
                    this.$notify({
                        title: "Success",
                        text: "Permission has been added successfully. ",
                        type: "success"
                    });

                } catch (e) {
                    this.$notify({
                        title: "Error",
                        text: "Failed to adding permission.." + e.message,
                        type: "error"
                    });
                }

                console.log(this.permissionForm);
            },
            openClosePermissionModal() {
                this.$emit("openClosePermissionModal");
            },
            setRole(value) {
                this.permissionForm.roleId = parseInt(value);
                console.log(this.selectedPermissionRole);
            },
            setPermissionForm() {
                this.permissionForm.roleId = this.selectedRoleId;
                console.log(this.permissionForm.roleId);
            },
        },
        computed: {
            ...mapState('roles', ['roles', 'rolesOfProject']),

            filteredRoles: function () {

                if (this.selectedRoleId != 0) {
                    return this.rolesOfProject.filter(x => x.id === this.selectedRoleId);
                } else {
                    return this.rolesOfProject;
                }
            },
        },
        created() {

            this.getRolesOfProject(parseInt(this.projectId));
            //this.permissionForm.roleId = this.rolesOfProject[0].id;
            console.log(this.permissionForm.roleId);
        }
    }
</script>

<style scoped>

</style>
